import { createFileRoute, redirect } from "@tanstack/react-router";

// English schema alias: BreadcrumbList → /sobre (navegação institucional)
export const Route = createFileRoute("/breadcrumb-list")({
  beforeLoad: () => {
    throw redirect({ to: "/equipe", replace: true });
  },
  component: () => null,
});
